import React, { useEffect } from "react";
import { useForm, useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { findActiveOrderIndex } from "../../../redux/reducers/newOrderReducer";
import { mobileRegex } from "../../../helpers/regex";

const OrderConfirmation = ({ data }) => {
  const wraperRef = React.useRef(null);
  const { register, errors, setValue } = useFormContext();
  const { enableCustomer, enableRemark } = useSelector((state) => state.util);
  const [count, setCount] = React.useState(0);
  const [display, setDisplay] = React.useState(false);
  const [numberMatch, setnumberMatch] = React.useState([]);

  useEffect(() => {
    if (data?.customerMobile && data?.customerName) {
      setValue("customerMobile", data?.customerMobile);
      setValue("customerName", data?.customerName);
    }
  }, [data]);

  const {
    activeOrder: refId,
    activeOrders,
    lastOrderNumber,
    kotNumber,
  } = useSelector((state) => state.order);
  const { customerData } = useSelector((state) => state.branch);

  const orderIndex = findActiveOrderIndex(activeOrders, refId);
  const currentOrder = activeOrders[orderIndex];

  const customerName = currentOrder?.customerName;
  const customerMobile = currentOrder?.customerMobile;

  const { tables } = useSelector((state) => state.branch);
  let tableType = tables.filter((table) => {
    return table?.tableNumber === currentOrder?.tableNumber;
  });

  const searchNumber = (text) => {
    const regex = new RegExp(`^${text}.*$`, "i");
    let matches = customerData.filter((data) => {
      return data?.customerMobile?.match(regex);
    });
    if (matches) {
      setDisplay(true);
    }
    const mobileNumbers = matches.map((x) => JSON.stringify(x)).map(JSON.parse);
    setnumberMatch(mobileNumbers);
  };

  const handleNumber = (e) => {
    setCount(e.target.value.length);
    searchNumber(e.target.value);
  };

  const SuggestionElement = (phone) => {
    let i;
    const number = [];
    // console.log(length)
    for (i = 0; i < count; i++) {
      number.push(<strong style={{ fontWeight: "bold" }}>{phone[i]}</strong>);
    }
    for (i = count; i < 10; i++) {
      number.push(<span>{phone[i]}</span>);
    }

    return number;
  };

  const handleClick = (customer) => {
    // console.log(customer);
    setValue("customerMobile", customer.customerMobile);
    setValue("customerName", customer.customerName);
    setDisplay(false);
  };

  const handleClickOutside = (e) => {
    const { current: wrap } = wraperRef;
    if (wrap && !wrap.contains(e.target)) {
      setDisplay(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    // console.log(previousOrders);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="px-2 pb-2 position-relative" style={{ zIndex: 2 }}>
      <form ref={wraperRef}>
        <div className="form-row">
          <div className="col">
            {enableCustomer && (
              <input
                name="customerMobile"
                type="text"
                className="form-control mt-3 "
                style={{
                  borderColor: "gray",
                }}
                ref={register({
                  pattern: {
                    value: mobileRegex,
                    message: "Invalid mobile Number",
                  },
                })}
                defaultValue={customerMobile}
                autocomplete="off"
                // onChange={(e) => handleChange(e)}

                // value={state.customerMobile}
                placeholder="Customer Mobile Number"
                onChange={(e) => handleNumber(e)}
              />
            )}
            {display && (
              <div
                className="position-relative"
                style={{
                  display: display ? "block" : "none",
                  backgroundColor: "transparent",
                  zIndex: 0,
                }}
              >
                <div
                  className="position-absolute top-0 left-0 bg-white w-100 p-1 border-bottom border-left border-right"
                  style={{ zIndex: 100 }}
                >
                  {numberMatch.map((item, index) => {
                    return (
                      <div
                        style={{
                          width: "100%",
                          fontSize: 12,
                          padding: "5px 10px",
                        }}
                        className="d-flex justify-content-start suggestion"
                        onClick={() => handleClick(item)}
                      >
                        {/* {console.log(item)} */}
                        {SuggestionElement(item.customerMobile)}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {errors.customerMobile && (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-start mt-2"
              >
                <span style={{ fontSize: 12, color: "red", textAlign: "left" }}>
                  {errors.customerMobile.message}
                </span>
              </div>
            )}
          </div>
          <div class="col">
            {enableCustomer && (
              <input
                type="text"
                name="customerName"
                className="form-control mt-3 "
                style={{
                  borderColor: "gray",
                }}
                placeholder="Customer Name"
                ref={register}
                defaultValue={customerName}

                // onChange={(e) => handleChange(e)}
              />
            )}
            {errors.customerName && <span>This field is required</span>}
          </div>
        </div>

        {/* {console.log(numberMatch)} */}

        {enableRemark && (
          <textarea
            name="remarks"
            rows="1"
            className="form-control mt-1"
            style={{
              borderColor: "gray",
            }}
            ref={register}
            // onChange={(e) => handleChange(e)}

            // value={state.remarks}
            placeholder="Remarks"
          />
        )}
        {/* <div className="d-flex align-items-center justify-content-around mt-3">
          <button type="submit" className="btn btn-primary ">
            Confirm
          </button>
        </div> */}
      </form>
    </div>
  );
};

export default OrderConfirmation;
